import React from "react"
import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
    Typography,
    Dialog,
    Modal,
    Tabs,
    Tab
} from "@mui/material";
import { callApi } from "../../common/api";
import { useEffect } from "react";
import { Box, display } from "@mui/system";
const AllNotifications = () => {
    const [value, setValue] = React.useState(0)
    const [notification, setNotification] = React.useState([])
    const getNotification = async () => {
        const response = await callApi('get', 'investor/allNotifications')
        setNotification(response?.data?.response?.data)
    }
    useEffect(() => {
        getNotification();
    }, [])
    const handleTabChange = (event, newValue) => {
        setValue(newValue)
    }
    
    return (
        <>
            <Box sx={{ padding: "10px", marginTop: "30px", marginLeft: "260px", width: "60%", border: "1px solid grey", borderRadius: "0.5rem", maxHeight: "600px",height:"600px", overflowY: "scroll"}}>
                <Typography sx={{ color: "white", fontSize: "24px", fontWeight: "500", padding: "10px" }}>Notification</Typography>
                <Box sx={{ display: "flex" }}>
                    <Tabs value={value} onChange={handleTabChange} centered>
                        <Tab sx={{ color: "white" }} label="All" />
                        <Tab sx={{ color: "white" }} label="Unread" />
                    </Tabs>
                </Box>

               { notification.length > 0 && <Box sx={{ alignSelf: "stretch", border: "1px solid grey", marginTop: "20px" }}></Box> }
               
                {notification && notification.map((ele, index) => {
                    <Box sx={{ alignSelf: "stretch", border: "1px solid grey", marginTop: "20px" }}></Box>
                    return (
                        <>
                            <Box sx={{ display: "flex", marginTop: "20px", gap: "10px", padding: "10px" }}>
                                <img
                                    style={{ height: "40px", width: "40px", backgroundColor: "#69B0F1", borderRadius: "1rem" }} src="/Frame.png"
                                />
                                <Box sx={{ width: "100%" }}>
                                    <Typography sx={{ color: "white", fontSize: "20px" }}>{ele?.title}</Typography>
                                    <Typography sx={{ color: "white", width: "90%" }}>{ele?.message}</Typography>
                                </Box>
                            </Box>
                            {index === notification.length - 1 ? (
                                <></>
                            ) : (
                                <Box sx={{ alignSelf: "stretch", border: "1px solid grey", marginTop: "20px" }}></Box>
                            )}
                        </>
                    )
                })}
            </Box>
        </>
    )
}
export default AllNotifications;